import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

const progressTrackingHistoryKeys = {
  all: ['projectProgressTrackingHistory'],
  byProject: (projectId) => [...progressTrackingHistoryKeys.all, 'project', projectId],
  monthlyOverview: () => [...progressTrackingHistoryKeys.all, 'monthly-overview'],
};

/**
 * Hook para obtener el historial de avance de un proyecto.
 *
 * @param {string} projectId - UUID del proyecto.
 * @param {Object} options - Opciones de React Query.
 * @returns {Object} Query con timeline y entries del historial.
 */
export const useProjectProgressTrackingHistory = (projectId, options = {}) => {
  return useQuery({
    queryKey: progressTrackingHistoryKeys.byProject(projectId),
    queryFn: async () => {
      const response = await apiClient.get(
        `project_progress_tracking_history/by-project/${projectId}`
      );
      return response.data;
    },
    enabled: !!projectId,
    staleTime: 2 * 60 * 1000,
    ...options,
  });
};

/**
 * Hook para obtener evolucion mensual de avance agregado de todos los proyectos.
 *
 * @param {Object} options - Opciones de React Query.
 * @returns {Object} Query con serie mensual agregada.
 */
export const useProjectProgressTrackingMonthlyOverview = (options = {}) => {
  return useQuery({
    queryKey: progressTrackingHistoryKeys.monthlyOverview(),
    queryFn: async () => {
      const response = await apiClient.get('project_progress_tracking_history/monthly-overview');
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
